export function columnTheme() {
  return {
    "&:nth-child(0)": {
      width: "15px",
    },
    "&:nth-child(1)": {
      width: "20px",
    },
    "&:nth-child(2)": {
      minWidth: "105px",
      maxWidth: "105px",
      width: "105px",
    },
    "&:nth-child(3)": {
      minWidth: "150px",
      maxWidth: "300px",
      width: "250px",
    },
    "&:nth-child(4)": {
      minWidth: "125px",
      maxWidth: "175px",
      width: "175px",
    },
    "&:nth-child(5)": {
      minWidth: "100px",
      maxWidth: "75px",
      width: "105px",
    },
    "&:nth-child(6)": {
      minWidth: "100px",
      maxWidth: "70px",
      width: "70px",
    },
    "&:nth-child(7)": {
      minWidth: "100px",
    },
    "&:nth-child(8)": {
      minWidth: "100px",
    },
    "&:nth-child(9)": {
      width: "100px",
    },
    "&:nth-child(10)": {
      width: "150px",
    },
    "&:nth-child(11)": {
      width: "50px",
    },
  }
}
